import type { RouteRecordRaw } from 'vue-router'
import { INDEX_LAYOUT, INDEX_SEARCH_LAYOUT, PAGE_LAYOUT } from '@/router/constant'
// import Search from '@/views/search/index.vue'

/** 积分榜 */
const index: RouteRecordRaw = {
  path: '/score-page',
  name: 'score-page',
  component: PAGE_LAYOUT,
  children: [
    {
      path: '/score-layout',
      name: 'score-layout',
      component: INDEX_LAYOUT,
      redirect: '/score',
      children: [
        {
          path: '/score',
          name: 'score',
          meta: {
            title: '积分榜',
            keepAlive: true,
          },
          component: () => import('@/views/score/index.vue'),
        },
      ],
    },
  ],
}

export default index
